// React imports
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Bio from './pages/Bio'
import Shows from './pages/Shows'
import Gallery from './pages/Gallery'
import Social from './pages/Social'
import Booking from './pages/Booking'
import Video from './pages/Video'
import Impressum from './pages/Impressum'
import Privacy from './pages/Privacy'
import EventBanner from './components/EventBanner'
import BackgroundVideo from './components/BackgroundVideo'
import ScrollToTop from './components/ScrollToTop'
import { LanguageProvider } from './contexts/LanguageContext'
// SoundCloud player moved to page content

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <BackgroundVideo />
          <EventBanner />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bio" element={<Bio />} />
            <Route path="/shows" element={<Shows />} />
            <Route path="/video" element={<Video />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/social" element={<Social />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          <Footer />
        </div>
        <Analytics />
      </Router>
    </LanguageProvider>
  )
}

export default App
